import { OrderTermsAPI } from '@business/api/order';
import { OrderTermId, OrderTermResponse } from '@business/entities/order';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class OrderTermBloc extends BaseBloc {
  private readonly termsRepo = new Repository<OrderTermResponse>({
    getItemId: term => term.id,
  });

  readonly terms$ = this.termsRepo.items$;
  readonly selectTerm = this.termsRepo.selectItem;

  onReset() {
    this.termsRepo.reset();
  }

  fetchTerms = () => {
    return OrderTermsAPI.fetchTerms().pipe(this.termsRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_order_terms_error') }));
  };

  fetchTerm = (id: OrderTermId) => {
    return OrderTermsAPI.fetchTerm(id).pipe(
      this.termsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_order_terms_error') }),
    );
  };

  createTerm = (data: Partial<OrderTermResponse>) => {
    return OrderTermsAPI.createTerm(data).pipe(
      this.termsRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_order_term'),
      }),
    );
  };

  updateTerm = (id: OrderTermId, data: Partial<OrderTermResponse>) => {
    return OrderTermsAPI.updateTerm(id, data).pipe(
      this.termsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_order_term'),
      }),
    );
  };

  deleteTerm = (id: OrderTermId) => {
    return showDeleteConfirmation('Delete Term', `Do you really want to remove this term?`).pipe(
      switchMap(() => OrderTermsAPI.deleteTerm(id)),
      this.termsRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_order_term'),
      }),
    );
  };
  sync = () => {
    return OrderTermsAPI.sync().pipe(
      this.termsRepo.ops.upsertMany(item => ({ item })),
      handleMessage({
        type: requestMessage('sync_order_product'),
      }),
    );
  };
}
